module.exports = __webpack_public_path__ + "img/7_111.c806b417.png";